import Vue from "vue"

export function displayCountingDateTimeValue (data, en){
    if (data == undefined){
        return '0 秒'
    }
    if (!typeof(data).isNumber){
        console.log('类型不是NUMBER')
        return '0 秒'
    }
    if(data < 0){
        return '0天 0小时 00分 0秒'
    }
    var leftSeconds = Math.round(data / 1000)
    let days = Math.floor(leftSeconds / 3600 / 24)
    leftSeconds = leftSeconds - days * 24 * 3600
    let hours = Math.floor(leftSeconds / 3600)
    let minutes = Math.floor((leftSeconds - hours * 3600) / 60)
    let seconds = leftSeconds - hours * 3600 - minutes * 60
    let minuteStr = minutes <=9 ? '0' + minutes : minutes
    let secondStr = seconds <= 9 ? '0' + seconds : seconds
    if(en != undefined){
        return days + '(DAY) ' + hours + '(H) '+minuteStr+'(M) '+secondStr+'S'    
    }

    return days + '天 ' + hours + '小时 '+minuteStr+'分 '+secondStr+'秒'
}

// 日期转换成时间毫秒数
export function dateToMillionSeconds(timestr){
    // console.log('当前时间：',timestr)
    let t = new Date(timestr)
    // console.log('转换后：',t)
    // console.log('返回：',t.getTime())
    return t.getTime()
}

export function formateJavaTimeString(timeString){
    if(timeString == undefined || timeString == ''){
        return '--:--:--'
    }
    let subTime = timeString.replace('T',' ')
    let result = subTime.substring(0,subTime.indexOf('.'))
    // console.log('日期格式',result)
    return result
}

export function displayCountingTimeValue (data){
    if (data == undefined){
        return '00:00:00'
    }
    if (!typeof(data).isNumber){
        console.log('类型不是NUMBER')
        return '00:00:00'
    }
    if(data < 0){
        return '00:00:00'
    }
    var leftSeconds = Math.round(data / 1000)
    let hours = Math.floor(leftSeconds / 3600)
    let minutes = Math.floor((leftSeconds - hours * 3600) / 60)
    let seconds = leftSeconds - hours * 3600 - minutes * 60

    let hourStr = hours < 10? '0'+ hours.toString() : hours.toString()
    let minuteStr = minutes < 10? '0'+ minutes.toString() : minutes.toString()
    let secondStr = seconds < 10? '0'+ seconds.toString() : seconds.toString()
    return  hourStr + ':'+minuteStr+':'+secondStr
}

function exchangedArr(arr,front, behind){
    if(arr == undefined || arr.length == 0) {
        return []
    }
    var f = 0
    if(front != undefined && front < arr.length){
        f = front
    }
    var  b = 0
    if(behind != undefined && b < arr.length){
        b = behind
    }
    if(f == b){
        return arr
    }
    // 交换两个元素
    var newArr = JSON.parse(JSON.stringify(arr))
    Vue.set(newArr,front, arr[behind])
    Vue.set(newArr,behind, arr[front])
    return newArr
}
export function mixSortedArray(arr,times){
    var time = 1
    if(times != undefined){
        time = times
    }
    var newArr = arr
    if(time > 0){
        let min = 0; 
        let max = arr.length
        for (let index = 0; index < time; index++) {
            let front = 0
            var behind =  Math.floor(Math.random() * (max - min)) + min
            if(behind == 0){
                behind = 3
            }
            newArr = exchangedArr(arr,front,behind)
       }  
    }
    return newArr
    
}

// <0 过期， =0 接近过期  >0 正常
export function calcExpiration(expir){
    let now = new Date().getTime()
    let detla = expir - now
    let days30 = 1000 * 60 * 60 * 24 * 30 // 30天有效期
    if(detla <= 0){ // 已过期
        return -1
    }else if(detla > 0 && detla <= days30){
        return 0
    }   
    return  1
}


export function getEbookLevelByValue(val){
    if(val == undefined || val == '') return val
    // console.log("val val",val)
    switch(val.toString()){
    case '1':
        return 'P1 Normal Chinese'
    case '2':
        
        return 'P1 Higher Chinese'
    case '3':
        return 'P2 Normal Chinese'
    case '4':
        return 'P2 Higher Chinese'

    case '5':
        return 'P3 Normal Chinese'

    case '6':
        return 'P3 Higher Chinese'
    case '7':
        return 'P4 Normal Chinese'
    case '8':
        return 'P4 Higher Chinese'
    default:
        return ''
    }
}


// WEBPACK FOOTER //
// ./src/utils/time_util.js